module.exports = __webpack_public_path__ + "img/7.a5b06364.png";